<template>
  <LoaderComponent :value="promise" class="reference-property-changes" theme="default">
    <div v-if="properties.length" class="reference-property-changes__properties">
      <template v-for="(property, index) in value">
        <Row
          v-if="getProperty(property.key)"
          :value="property"
          :property="getProperty(property.key)"
          @input="$ev => update($ev, index)"
          @remove="$ev => remove(index)"
          :key="property.key"
        />
      </template>
    </div>
    <div class="reference-property-changes__unused-properties">
      <ButtonComponent
        v-for="property in unusedProperties"
        :key="property.key"
        :label="property.label || $tc(property.key)"
        theme="default"
        :icon="['fal', 'plus']"
        type="button"
        @click="() => add(property)"
      />
      <AlertComponent v-if="!properties.length" theme="primary">{{
        $t('shopReferencePropertyNoPropertiesMessage')
      }}</AlertComponent>
    </div>
  </LoaderComponent>
</template>

<script>
import { mapState } from 'vuex'
import ResidentialApi from '@/api/Residential'
import ResidentialTemplateApi from '@/api/ResidentialTemplate'
import { LoaderComponent } from 'vue-elder-loader'
import Row from './Row.vue'
import { ButtonComponent } from 'vue-elder-button'
import { isNumeric } from '@/utils'
import { AlertComponent } from 'vue-elder-alert'

const ignoredProperties = ['constructionYear']

export default {
  name: 'ReferencePropertyChanges',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      promise: null,
      properties: [],
    }
  },
  computed: {
    ...mapState('Shop', ['item']),
    unusedProperties() {
      return this.properties.filter(property => !this.value.find(({ key }) => key === property.key))
    },
  },
  methods: {
    getProperty(key) {
      return this.properties.find(property => property.key === key)
    },
    add(property) {
      this.value.push({ key: property.key, delta: 0 })
    },
    update(value, index) {
      this.$emit('input', this.value.toSpliced(index, 1, value))
    },
    remove(index) {
      this.$emit('input', this.value.toSpliced(index, 1))
    },
    fetch() {
      const isTemplate = this.$path('item.reference.__typename') === 'ResidentialTemplate'
      const api = isTemplate ? ResidentialTemplateApi : ResidentialApi
      const query = isTemplate ? 'ResidentialTemplateProperties' : 'ResidentialProperties'

      return (this.promise = api.get({ id: this.$store.getters['Shop/reference'] }, { query }).then(
        res =>
          (this.properties = ((res && res.properties) || []).filter(p => {
            if (ignoredProperties.includes(p.key)) return false
            if (!isNumeric(p.value)) return false
            return true
          })),
      ))
    },
  },
  created() {
    this.fetch()
  },
  components: {
    ButtonComponent,
    Row,
    LoaderComponent,
    AlertComponent,
  },
}
</script>

<style lang="scss">
.reference-property-changes {
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);

  padding-block: 1rem;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  .alert {
    font-size: 1em;
    flex-grow: 1;
  }

  &__properties {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &:empty {
      display: none;
    }
  }

  &__unused-properties {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    font-size: 0.8em;
  }
}
</style>
